import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { object, string, array } from 'yup';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import InputTypeNumber from '../../../common/components/InputTypeNumber/InputTypeNumber';
import DateAndTimePickers from '../../../common/components/DateTimePicker/DateTimePicker';
import {
  addDisbursement,
  uploadDisbursementDocs,
  uploadedDisbusementDocs,
  UploadFileToS3
} from '../../../common/constants/api';
import _ from 'lodash';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
const initialImg = '/images/icons/upload_new.svg';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { enableGATracking } from 'gatsby-env-variables';
const RecuringDisbursement = props => {
  const [startDate, setStartDate] = useState(null);
  const [disbursementProofId, setDisbursementProofId] = useState('');
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);

  const validationSchema = object().shape({
    transactionId: string()
      .matches(/^[A-Za-z0-9_ ]*$/, 'Please enter valid transaction id')
      .min(2, 'Minimum 2 character required')
      .max(50, 'Maximum 50 character')
      .required('Required'),
    disbursementAmount: string()
      .min(1, 'Please enter correct amount')
      .required('Required'),
    file: array().test(value => {
      let isTrue = true;
      if (!_.get(value, '[0][0]', false)) isTrue = false;
      return isTrue;
    })
    // disburseDate: string().required('Required')
  });
  return (
    <Formik
      initialValues={{
        transactionId: '',
        disbursementDate: '',
        disbursementAmount: '',
        comments: '',
        file: [],
        imgUrl: []
      }}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting }) => {
        props.setShow(true);
        props.setText('Loading...');
        props.setType('loading');
        let body = {
          disbursedDate: startDate,
          disbursedAmount: values?.disbursementAmount,
          transactionId: values?.transactionId,
          proofDocId: disbursementProofId,
          comment: values?.comments
        };
        addDisbursement(leadId, body)
          .then(res => {
            props.setType('success');
            props.setText('Disburment has been added successfully!');
            props?.setShowModal(false);
            setTimeout(() => {
              props.setShow(false);
              typeof props?.successCall == 'function' && props?.successCall();
            }, 2000);
            if (enableGATracking) {
              ga(
                'send',
                'event',
                'Button',
                'Click',
                'Disbursed',
                values?.disbursementAmount,
                { disbursedAmount: values?.disbursementAmount }
              );
            }
          })
          .catch(err => {
            props?.setShow(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        setFieldError,
        setFieldTouched,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => {
        const statusforUpload = (data, docName) => {
          uploadedDisbusementDocs(leadId, docName, data?.requestId)
            .then(res => {
              if (res?.error) {
                throw new Error(res);
              }
              if (docName == 'disbursement-proof') {
                setDisbursementProofId(data?.requestId);
              }
              props?.setType('success');
              props?.setText('File uploaded successfully.');
              props?.setShow(true);
            })

            .catch(async err => {
              setShow(false);
            });
        };
        const uploadFileToS3 = (data, file, docName) => {
          if (data?.url && data?.requestId) {
            UploadFileToS3(data.url, file)
              .then(res => {
                if (res?.error) {
                  throw new Error(res);
                }
                statusforUpload(data, docName);
              })
              .catch(async err => {
                props?.setShowModal(false);
                props?.setShow(false);
              });
          }
        };

        const getS3Url = (index, docName) => {
          if (values?.file[index] && values?.file[index][0]) {
            props?.setType('loading');
            props?.setText('Uploading the File Please Wait...');
            props?.setShow(true);
            let file = values?.file[index][0];
            uploadDisbursementDocs(leadId, docName)
              .then(res => {
                if (res?.error) {
                  throw new Error(res);
                }

                uploadFileToS3(res, file, docName);
              })
              .catch(async err => {
                props?.setShowModal(false);
                props?.setShow(false);
              });
          }
        };

        useEffect(() => {
          getS3Url(0, 'disbursement-proof');
        }, [values?.file[0]]);
        return (
          <div className="pt-1 mb-5 overflow-auto">
            <Form onSubmit={handleSubmit}>
              <div className="relative flex flex-col content-center space-y-6 pt-2 py-3">
                <div className="w-full">
                  <CommonInput
                    name="transactionId"
                    id="transactionId"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values?.transactionId}
                    stylesContainer={{
                      maxWidth: '100%',
                      color: '#545454'
                    }}
                    legendName="Transaction Id"
                    error={touched?.transactionId && errors?.transactionId}
                    errorMsg={errors?.transactionId}
                    touched={touched?.transactionId}
                  />
                </div>
                <div className="w-full flex flex-col lg:flex-row justify-between">
                  <div className="w-full lg:w-6/12 pr-1">
                    <DateAndTimePickers
                      name="disburseDate"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      startDate={startDate}
                      setStartDate={setStartDate}
                      placeholderText="Disbursement Date"
                      isFutureDisabled
                      inputStyle={{
                        height: '52px',
                        color: '#545454',
                        width: '90%'
                      }}
                    />
                  </div>

                  <div className="w-full lg:w-6/12 pl-1 mt-6 lg:mt-0">
                    <InputTypeNumber
                      name="disbursementAmount"
                      value={values.disbursementAmount}
                      maxLength={15}
                      minLength={0}
                      legendName="Disbursement Amount"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      stylesContainer={{
                        maxWidth: '100%',
                        color: '#545454'
                      }}
                      inputStyle={{
                        height: '30px',
                        paddingTop: '10px',
                        letterSpacing: '1px'
                      }}
                      legendStyle={{ paddingLeft: '0px' }}
                      iconStyle={{ marginTop: '12px' }}
                      error={
                        touched.disbursementAmount && errors.disbursementAmount
                      }
                      errorMsg={errors.disbursementAmount}
                      touched={touched.disbursementAmount}
                      setFieldValue={setFieldValue}
                      showInText={false}
                      rupeeIcon={false}
                    />
                  </div>
                </div>
                <div className="w-full">
                  <textarea
                    className="w-full mr-3 p-2 text-black-400 border border-grey-350 hover:border-green-600 rounded"
                    cols="30"
                    rows="3"
                    name="comments"
                    id="comments"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    placeholder="Please write comments"
                  ></textarea>
                </div>
                <div className="w-auto mr-auto px-1 my-3">
                  <p className="w-full text-sm font-roboto font-normal text-grey-300 mb-2">
                    Add Doc Proof
                  </p>
                  <div className={`flex`}>
                    <GlobalUploadComp
                      data={values}
                      imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      initialImg={initialImg} // initial image
                      subInst="click here or  drop here to upload "
                    />
                  </div>
                </div>
                <button
                  id="lems_disbursementAddBtn"
                  type="submit"
                  className="submitButton capitalize font-roboto"
                  disabled={!_.isEmpty(errors) || startDate == null}
                >
                  Add Disbursement
                </button>
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};
export default RecuringDisbursement;
